import { useQuery } from '@tanstack/react-query'
import React, { createContext, useContext, useEffect, useMemo, useRef } from 'react'
import { Outlet, useLocation, useNavigation, useParams } from 'react-router-dom'
import { formDocumentQuery } from '../../api/document/document-loader'
import { elHFull, MainContainer } from '@reapit/elements'
import { displayViewMap, IFormDocumentData } from '../../api/document'
import { Navigate } from 'react-router-dom'

export const FormDocumentContext = createContext<IFormDocumentData | null>(null)
export const FormDocumentProvider = FormDocumentContext.Provider
export const useFormDocument = () => {
  const result = useContext(FormDocumentContext)
  return result
}

export const TenantLayout: React.FC = () => {
  const { recipientId } = useParams<string>()
  const { data: formDocumentData, isError, isLoading } = useQuery(formDocumentQuery(recipientId))
  const pathName: string = useLocation().pathname
  const isFirstRendered = useRef<boolean>(true)
  const isRedirected = useRef<boolean>(false)
  const isLoadingPage: boolean = useNavigation().state === 'loading'
  const welcomePath: string = useMemo(() => `/${recipientId}`, [recipientId])
  const stepPath: string = useMemo(() => `/${recipientId}/steps/${formDocumentData?.nextStep}/`, [recipientId])

  useEffect(() => {
    isFirstRendered.current = false
  }, [])

  if (isLoading) return null
  if (isError || !formDocumentData) return <Navigate to={'/not-found'} replace />

  if (isFirstRendered.current) {
    switch (formDocumentData.displayView) {
      case displayViewMap.welcome:
        if (welcomePath.replaceAll('/', '') !== pathName.replaceAll('/', '')) {
          isRedirected.current = true
          return <Navigate to={welcomePath} replace />
        }
        break
      case displayViewMap.step:
        if (stepPath.replaceAll('/', '') !== pathName.replaceAll('/', '')) {
          isRedirected.current = true
          return <Navigate to={stepPath} replace />
        }
        break
      case displayViewMap.inactiveLink:
        isRedirected.current = true
        return <Navigate to={`${welcomePath}/broken-link`} replace />
      case displayViewMap.submitted:
        isRedirected.current = true
        return <Navigate to={`${welcomePath}/succes/submited`} replace />
      case displayViewMap.changeRequest:
        isRedirected.current = true
        return <Navigate to={`${welcomePath}/succes/changed-request`} replace />
      case displayViewMap.error:
        return <Navigate to="/not-found" replace />
    }
  }

  if (isLoadingPage && isRedirected.current) return null
  if (!isFirstRendered.current) isRedirected.current = false

  return (
    <FormDocumentProvider value={formDocumentData || null}>
      <MainContainer className={elHFull}>
        <Outlet />
      </MainContainer>
    </FormDocumentProvider>
  )
}

export const TenantAppErrorHandler: React.FC = () => <Navigate to={'/not-found'} />
